import { ScreenPrimitiveLoadInfo } from "../interface/screen-primitive-load-info";

export const GLOBAL_NAMESPACE = 'tiny_monix.';
export const AUTHORIZATION = GLOBAL_NAMESPACE + 'authorization';
export const REMEMBER_USERNAME = GLOBAL_NAMESPACE + 'username';
export const REMEMBER_PASSWORD = GLOBAL_NAMESPACE + 'password';
export const REMEMBER_TAG = GLOBAL_NAMESPACE + 'remember';
export const PROJECT_UUID = GLOBAL_NAMESPACE + 'project_uuid';
export const PROJECT_NAME = GLOBAL_NAMESPACE + 'project_name';
export const USER_ID = GLOBAL_NAMESPACE + 'user_id';
export const USER_UUID = GLOBAL_NAMESPACE + 'user_uuid';
export const USER_NAME = GLOBAL_NAMESPACE + 'user_name';
export const USER_DETAIL = GLOBAL_NAMESPACE + 'user_detail';
export const LOCAL_USER_TYPE = GLOBAL_NAMESPACE + 'user_type';
export const SELECTED_PANEL = GLOBAL_NAMESPACE + 'selected_panel';
export const PROJECT_LIST = GLOBAL_NAMESPACE + 'project_list';
export const TABBAR_CLOSABLE = `${GLOBAL_NAMESPACE}_tabbar_closable`;
// 大屏图元加载接口统计
export const SCREEN_PRIMITIVE_LOAD_INFO = GLOBAL_NAMESPACE + 'screen_primitive_load_info';

class LocalStore {

    public get(key: string) {
        return JSON.parse(localStorage.getItem(key) || 'null') || null;
    }

    public set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public remove(key: string): void {
        localStorage.removeItem(key);
    }

    get token(): string {
        return this.get(AUTHORIZATION) || '';
    }

    set token(value: string) {
        this.set(AUTHORIZATION, value);
    }

    get projectId(): string {
        return this.get(PROJECT_UUID) || '';
    }

    set projectId(value: string) {
        this.set(PROJECT_UUID, value);
    }

    get userId(): number {
        return this.get(USER_ID) || '';
    }
    set userId(value: number) {
        this.set(USER_ID, value);
    }

    get userUuid(): string {
        return this.get(USER_UUID) || '';
    }
    set userUuid(value: string) {
        this.set(USER_UUID, value);
    }

    get name(): string {
        return this.get(USER_NAME) || '';
    }
    set name(value: string) {
        this.set(USER_NAME, value);
    }

    // get password(): string {
    //     return this.get(REMEMBER_PASSWORD) || '';
    // }
    // set password(value: string) {
    //     this.set(REMEMBER_PASSWORD, value);
    // }

    public setSelectedPanel(value: string) {
        if (value == null) {
            this.remove(SELECTED_PANEL);
            return;
        }
        this.set(SELECTED_PANEL, value);
    }

    public getSelectedPanel() {
        return this.get(SELECTED_PANEL);
    }

    public setProjectId(value: string) {
        if (value == null) {
            this.remove(PROJECT_UUID);
            return;
        }
        this.set(PROJECT_UUID, value);
    }

    public getProjectId() {
        return this.get(PROJECT_UUID);
    }

    public setProjectName(value: string) {
        if (value == null) {
            this.remove(PROJECT_NAME);
            return;
        }
        this.set(PROJECT_NAME, value);
    }

    public getProjectName() {
        return this.get(PROJECT_NAME);
    }

    /**
     * 保存指定项目的图元加载接口统计。
     */
    public setScreenPrimitiveLoadInfo(projectId: string, value: Partial<ScreenPrimitiveLoadInfo>,) {
        if (!projectId) {
            return;
        }

        const map =
            this.get(
                SCREEN_PRIMITIVE_LOAD_INFO,
            ) || {};

        map[projectId] = {
            ...(map[projectId] || {}),
            ...value,
            projectId,
            updateTime: Date.now(),
        };

        this.set(
            SCREEN_PRIMITIVE_LOAD_INFO,
            map,
        );
    }

    /**
     * 获取指定项目的图元加载接口统计。
     */
    public getScreenPrimitiveLoadInfo(projectId: string,): ScreenPrimitiveLoadInfo | null {
        if (!projectId) {
            return null;
        }

        const map =
            this.get(
                SCREEN_PRIMITIVE_LOAD_INFO,
            ) || {};

        return map[projectId] || null;
    }

    clearProjectInfo() {
        this.remove(SELECTED_PANEL);
        this.remove(PROJECT_UUID);
        this.remove(PROJECT_NAME);
    }

    clear() {
        this.remove(AUTHORIZATION);
        this.remove(PROJECT_UUID);
        this.remove(PROJECT_NAME);
        this.remove(USER_ID);
        this.remove(USER_UUID);
        this.remove(USER_NAME);
        this.remove(LOCAL_USER_TYPE);
        this.remove(PROJECT_LIST);
    }
}

export default new LocalStore();